import {useEffect, useMemo, useState} from "react";
import {useAppDispatch, useAppSelector} from "@/redux/hooks";
import {setProductsParamsRaw} from "@/redux/products.slice";
import {useSearchParams} from "next/navigation";
import {useProductList} from "@/lib/api";
import {createParamsFromQueries, createQueriesFromSearchParams, getQueryString} from "@/lib/url/query-string";
import {IProductNew} from "@/types/product";

export const useProducts = (initialData: any, initialQueryString: string) => {
    const dispatch = useAppDispatch();
    const searchParams = useSearchParams();
    const productParams = useAppSelector((state) => state.products);
    const [urlStateInitialized, setUrlStateInitialized] = useState(false);

    const parsed = useMemo(() => {
        return createParamsFromQueries(
            createQueriesFromSearchParams(searchParams)
        );
    }, [searchParams]);

    useEffect(() => {
        dispatch(setProductsParamsRaw(parsed));
        setUrlStateInitialized(true);
    }, [dispatch, parsed]);

    const activeParams = urlStateInitialized ? productParams : parsed;
    const clientQueryString = useMemo(() => getQueryString(activeParams), [activeParams]);
    const initialDataMatches = clientQueryString === initialQueryString;
    const { data, isLoading, isValidating } = useProductList<IProductNew>(
        activeParams,
        initialDataMatches ? initialData : undefined,
        {revalidateOnMount: !initialDataMatches}
    );

    return {
        productsData: data,
        products: data?.data || [],
        page: activeParams.Page,
        isExists: activeParams.isExists,
        isLoading,
        isValidating,
    };
};
